import General from "./general"
import French from "./french"
import English from "./english"
import Spanish from "./spanish"
import Numbers from "./numbers"

export function getKeyBoardTemplate(
  language,
  fullKeyboard = true,
  withNumericPad = false
) {
  const general = fullKeyboard ? General : []
  const numbers = withNumericPad ? Numbers : []
  switch (language?.toLowerCase()) {
    case "french":
      return [...general, ...numbers, ...French]
    case "english":
      return [...general, ...numbers, ...English]
    case "spanish":
      return [...general, ...numbers, ...Spanish]
    default:
      return [...general, ...numbers]
  }
}
